/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal, HelpBlock } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import OzTabs from '../lib/OzTabs';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken, addUrlParam, getParams } from '../utils/util';
import './LeaderboardEmbed.css';
import Wrapper from './Wrapper';
import LeaderboardWidget from './partials/LeaderboardWidget';

import {
} from '../actions';


class LeaderboardEmbed extends OzComponent {

  static need = [
  ];

  componentDidMount() {
    try {
      let sheet = window.document.styleSheets[0];
      sheet.insertRule('#drift-widget-container { display: none; }', sheet.cssRules.length);
    } catch (e) { }
  }

  render() {
    return (
      <div className="LeaderboardEmbed">
        <LeaderboardWidget roomId={this.props.params.id} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LeaderboardEmbed);



/** WEBPACK FOOTER **
 ** ./src/components/LeaderboardEmbed.js
 **/